var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 15,
    height: 15,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.25,
    width: 2.5,
    height: 2.5,
    rx: 0.5,
    fill: "#1B4B86"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 5.85,
    width: 5.75,
    height: 1.3,
    rx: 0.65,
    fill: "#1B4B86"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.75,
    width: 2.5,
    height: 2.5,
    rx: 0.5,
    fill: "#1B4B86"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 9.35,
    width: 5.75,
    height: 1.3,
    rx: 0.65,
    fill: "#1B4B86"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12.25,
    width: 2.5,
    height: 2.5,
    rx: 0.5,
    fill: "#1B4B86"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 12.85,
    width: 5.75,
    height: 1.3,
    rx: 0.65,
    fill: "#1B4B86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestManagement);
export default __webpack_public_path__ + "static/media/icon_quest_management.5bda928cd686abe25baa2ba085bec237.svg";
export { ForwardRef as ReactComponent };